import {StyleSheet} from 'react-native';
import {Colors} from '../../../constants/Colors';

export const styles = StyleSheet.create({
  container: {
    width: '100%',
    maxWidth: 500,
    alignSelf: 'center',
    flex: 1,
    backgroundColor: 'white',
    borderRadius: 8,
    paddingHorizontal: 30,
    paddingVertical: 60,
  },
  imageBackground: {
    flex: 1,
    paddingHorizontal: 15,
    justifyContent: 'center',
    paddingVertical: 30,
    backgroundColor: '#e61c2b'
  },
  simbol: {alignSelf: 'center', marginBottom: 50},
  recover: {
    fontSize: 22,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 26,
    textAlign: 'center',
    color: 'black',
    maxWidth: 250,
    alignSelf: 'center',
  },
  description: {
    fontSize: 16,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 20,
    color: 'black',
    textAlign: 'center',
    maxWidth: 280,
    alignSelf: 'center',
    marginTop: 20,
  },
  containerButton: {marginTop: 60},
  containerBack: {
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'center',
    marginTop: 20,
  },
  goBack: {
    color: Colors.RedPallete.red,
    marginLeft: 10,
    fontFamily: 'TCCC-UnityHeadline Regular',
  },
  containerArrow: {
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'center'
  },
  arrowButton: {position: 'absolute', left: 10, height: 30, width: 30}
});
